import React from "react";
import { FaClock } from "react-icons/fa";
import { colors, spacing, radius, shadows, typography, transitions } from "../utils/designTokens";

const EmptyStateComingSoon = ({ icon, title, description }) => {
  return (
    <div style={styles.container}>
      <div style={styles.iconWrapper}>
        {icon || <FaClock />}
      </div>
      <h3 style={styles.title}>{title || "Proximamente"}</h3>
      <p style={styles.description}>
        {description || "Esta funcionalidad estara disponible pronto."}
      </p>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: `${spacing[12]}px ${spacing[6]}px`,
    textAlign: "center",
    backgroundColor: colors.bgCard,
    borderRadius: radius.md,
    boxShadow: shadows.sm,
    transition: `all ${transitions.normal}`,
  },
  iconWrapper: {
    width: 64,
    height: 64,
    borderRadius: radius.lg,
    backgroundColor: colors.primaryLighter,
    color: colors.primary,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 28,
    marginBottom: spacing[5],
  },
  title: {
    fontSize: typography.sizes.xl,
    fontWeight: 400,
    color: colors.black,
    margin: `0 0 ${spacing[2]}px 0`,
  },
  description: {
    fontSize: typography.sizes.md,
    color: colors.gray600,
    margin: 0,
    maxWidth: 360,
    lineHeight: 1.5,
  },
};

export default EmptyStateComingSoon;
